import { Link } from "react-router-dom";
import { Download, Facebook, Instagram, Mail } from "lucide-react";
import { ARTIST, PORTFOLIO_URL, siteImg } from "@/lib/constants";
import { ScallopStrip } from "@/components/motifs";
import { sectionPath, useSectionLink } from "@/components/Navbar";
import { PAGES } from "@/lib/site";

export const Footer = () => {
  const go = useSectionLink();
  return (
    <footer className="border-t border-border" data-testid="site-footer">
      <ScallopStrip className="text-foreground/20" />
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-5 py-16 text-center sm:px-8">
        <Link to="/" onClick={go("home")} className="group">
          <img
            src={siteImg("/assets/logo.png")}
            alt={`${ARTIST.name} logo`}
            className="h-24 w-24 rounded-full object-cover ring-1 ring-foreground/20 transition-transform duration-500 group-hover:scale-[1.03] sm:h-28 sm:w-28"
          />
        </Link>
        <div>
          <p className="font-serif text-2xl font-semibold tracking-tight sm:text-3xl">{ARTIST.name}</p>
          <p className="eyebrow mt-2 text-muted-foreground">{ARTIST.title}</p>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[13px] text-muted-foreground">
          {Object.keys(PAGES).map((id) => (
            <Link key={id} to={sectionPath(id)} onClick={go(id)} className="transition-colors hover:text-accent">
              {PAGES[id].name}
            </Link>
          ))}
          <Link to="/admin" rel="nofollow" data-testid="nav-link-admin" className="transition-colors hover:text-accent">
            Studio
          </Link>
        </nav>
        <div className="flex flex-col items-center gap-3">
          <a href={ARTIST.phoneHref} className="font-serif text-lg transition-colors hover:text-accent">
            {ARTIST.phone}
          </a>
          <a href={`mailto:${ARTIST.email}`} className="flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-accent">
            <Mail size={14} /> {ARTIST.email}
          </a>
          <div className="mt-1 flex items-center gap-3">
            <a href={ARTIST.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-colors hover:border-accent hover:text-accent">
              <Instagram size={15} />
            </a>
            <a href={ARTIST.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-colors hover:border-accent hover:text-accent">
              <Facebook size={15} />
            </a>
            <a href={PORTFOLIO_URL} aria-label="Download portfolio PDF (English)" data-testid="footer-portfolio-download" className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-colors hover:border-accent hover:text-accent">
              <Download size={15} />
            </a>
          </div>
        </div>
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
          © {new Date().getFullYear()} {ARTIST.name} · {ARTIST.location} · A living archive of Mithila art
        </p>
      </div>
    </footer>
  );
};
